// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__MZsnW","location":"Header_location__3Y2Pu"};